import React from 'react'
import cn from 'classnames'
import { Button, IconPlayDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import type { Module } from '../../types'
import { CampModuleNumber } from '../CampModuleNumber'
import { CampModule } from './CampModule'
import style from './Curriculum.module.scss'

interface CurriculumProps {
  modules: Module[]
  onOverviewClick: React.MouseEventHandler
}

type Responsive = {
  ltLG: boolean
  ltSM: boolean
}

export const Curriculum = (props: CurriculumProps) => (
  <>
    <div className='d-block d-sm-none'>
      <CurriculumResponsive {...props} ltLG ltSM />
    </div>
    <div className='d-none d-sm-block d-lg-none'>
      <CurriculumResponsive {...props} ltLG ltSM={false} />
    </div>
    <div className='d-none d-lg-block'>
      <CurriculumResponsive {...props} ltLG={false} ltSM={false} />
    </div>
  </>
)

const CurriculumResponsive = ({
  modules,
  onOverviewClick,
  ltLG,
  ltSM,
}: CurriculumProps & Responsive) => {
  const { t } = useTranslation('@mc/next')
  const trimmedModules = modules.slice(0, modules.length - 1)

  return (
    <>
      <div className={cn('mc-text--center mc-mt-12', { 'mc-pt-9': ltLG })}>
        <div className='row no-gutters justify-content-center'>
          <div className='col-12 col-lg-8'>
            <h2 className='mc-text-h1'>{t('sessions.curriculum.header')}</h2>
          </div>
        </div>
        <p className='mc-my-2 mc-text-large mc-opacity--muted'>
          {t('sessions.curriculum.explore')}
        </p>
        <Button className='mc-my-2' onClick={onOverviewClick}>
          <IconPlayDefault className='mc-mr-2' />
          {t('sessions.curriculum.overview')}
        </Button>
      </div>
      <div
        className={cn(style.curriculum, 'mc-bg-light mc-corners--sm mc-mb-12', {
          'mc-mt-10': !ltSM,
          'mc-mt-6': ltSM,
        })}
      >
        <div className='container--md d-flex align-items-center justify-content-between mc-py-2'>
          <h6 className='mc-text-h6'>
            {t('sessions.curriculum.myActivities')}
          </h6>
          <div className='col-auto'>
            <div
              className={`d-inline-flex align-items-center ${style.progressBar}`}
            >
              {trimmedModules.map(({ id, number }) => (
                <div key={id} className={style.progressBarNode}>
                  <CampModuleNumber moduleNumber={number} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={style.modules}>
          {trimmedModules.map((module) => (
            <CampModule key={`module-${module.id}`} module={module} />
          ))}
        </div>
      </div>
    </>
  )
}
